var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Interface / Arrow / Right Copy 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow down",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48025 0.451931C4.30001 0.271689 4.00778 0.271689 3.82754 0.451931L3.338 0.941467C3.15776 1.12171 3.15776 1.41394 3.338 1.59418L7.66256 5.91874C7.70762 5.9638 7.70762 6.03686 7.66256 6.08192L3.33833 10.4061C3.15809 10.5864 3.15809 10.8786 3.33833 11.0589L3.82754 11.5481C4.00778 11.7283 4.30001 11.7283 4.48025 11.5481L9.37561 6.65271C9.73609 6.29223 9.73609 5.70777 9.37561 5.34729L4.48025 0.451931Z",
    fill: "#1D1D1B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.7263bedbe5624bccc13b9ec46b9b7362.svg";
export { ForwardRef as ReactComponent };